import styled, { css, keyframes } from "styled-components";
import { SidebarArrowIcon } from "../../../Icons";
import { SectionItem, SectionItemContainer } from "./UI/Section/Section-styled";

// Define keyframes for expand animation
const peekSidebar = keyframes`
  0% {
    transform: translateX(-40px);
    box-shadow: none;
    background-color: rgba(255,255,255,0.7);
  }
  80% {
    transform: translateX(40px);
    box-shadow: none;
    background-color: rgba(255,255,255,0.7);
  }
  100% {
    transform: translateX(0px);
    box-shadow: none;
    background-color: rgba(255,255,255,0.7);
  }
`;

const peekScale = keyframes`
  0% { transform: scale(1); }
  40% { transform: scale(1.08); }
  60% { transform: scale(1); }
  80% { transform: scale(1.08); }
  100% { transform: scale(1); }
`;

export const SidebarContainer = styled.div`
  width: ${(props) => (props.expanded ? "240px" : "50px")};
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  background-color: #fff;
  border-right: 1px solid #d2d1d1;
  padding: 8px 0px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  position: fixed;
  left: 0px;
  top: 0px;
  width: ${(props) => (props.expanded ? "240px" : "50px")};
  height: 100%;
  z-index: 10;

  /* ${(props) =>
    props.animate &&
    !props.expanded &&
    css`
      animation: ${peekSidebar} 1s ease-in-out both;
      & ${SectionItemContainer}, & ${SectionItem} {
        animation: ${peekScale} 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
      }
    `} */
`;

export const SidebarButtonsContainer = styled.div`
  padding: 8px 8px 0px;
  border-top: 1px solid #eee;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;

export const SidebarBody = styled(SidebarButtonsContainer)`
  flex: 1;
  overflow: auto;

  ::-webkit-scrollbar {
    height: 100%;
    max-width: 4px;
    box-shadow: 0 0 2px #ffffff, 0 0 2px #ffffff;
    border-radius: 2px;
    background-color: #dfe6eb;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 2px #ffffff, 0 0 2px #ffffff;
    border-radius: 2px;
    width: 4px;
    min-height: 40px;
  }
`;

export const StyledSection = styled.div`
  display: ${(props) => (props.hide ? "none" : "flex")};
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  &:not(:empty):not(:last-child) {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #888888;
  padding: 8px 8px;
  text-transform: uppercase;
`;

export const SectionItemLogo = styled(SectionItem)`
  align-items: center;
  justify-content: center;

  svg {
    width: unset;
    height: unset;
  }
`;

export const StyledSidebarArrow = styled(SidebarArrowIcon)`
  transform: ${({ isRotate }) => (isRotate ? "rotate(90deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
`;

export const StyledFilterModalContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 80%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  overflow: hidden;
`;

export const StyledFiltersCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  line-height: 1 !important;
  background: var(--opsColor);
  color: var(--selectionFontColor);
  font-weight: 500;

  ${({ expanded }) =>
    expanded
      ? css`
          margin-left: auto;
          width: 14px;
          height: 14px;
          position: static;
          right: unset;
          top: unset;
          z-index: unset;
          font-size: 10px;
          padding: 1px;
        `
      : css`
          margin-left: 0;
          width: 10px;
          height: 10px;
          position: absolute;
          right: -4px;
          top: -4px;
          z-index: 1;
          font-size: 9px;
          padding: 2px;
        `}
`;

export const SidebarVersionContainer = styled.div`
  /* position: absolute;
  bottom: 2px;
  left: 4px; */
  font-size: 10px;
  color: var(--fontColor);
  padding-left: 8px;
`;

export const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: ${({ selected }) => (selected ? "rgba(0,0,0,0.5)" : "")};
  color: ${({ selected }) => (selected ? "white" : "")};
  border-radius: 6px;
`;
